var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.99935H4.66667M4.66667 4.99935H18M4.66667 4.99935V16.666C4.66667 17.108 4.84226 17.532 5.15482 17.8445C5.46738 18.1571 5.89131 18.3327 6.33333 18.3327H14.6667C15.1087 18.3327 15.5326 18.1571 15.8452 17.8445C16.1577 17.532 16.3333 17.108 16.3333 16.666V4.99935H4.66667ZM7.16667 4.99935V3.33268C7.16667 2.89065 7.34226 2.46673 7.65482 2.15417C7.96738 1.84161 8.39131 1.66602 8.83333 1.66602H12.1667C12.6087 1.66602 13.0326 1.84161 13.3452 2.15417C13.6577 2.46673 13.8333 2.89065 13.8333 3.33268V4.99935M8.83333 9.16602V14.166M12.1667 9.16602V14.166",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/deleteAccount.3187ee24bb960a09cb94b2268ed0ba75.svg";
export { ForwardRef as ReactComponent };